<template>
  <div>
    <!--START: Chat Window-->
    <ChatWindow
      v-if="chatWindow.show || chatWindow.initialised"
      ref="chatWindow"
      :widget="widget"
      :class="{ show: chatWindow.show }"
      @showLiveChat="showLiveChat"
      @closeChat="toggleWidget"
    ></ChatWindow>
    <!--END: Chat Window-->

    <!--START: Chat Button-->
    <ChatButton
      v-if="widget.widgetID"
      ref="chatButton"
      :widget="widget"
      :class="{ show: chatButton.show }"
      @buttonClicked="toggleWidget"
    ></ChatButton>
    <!--END: Chat Button-->
  </div>
</template>
  
<script>
// Importing Services
import { WidgetService } from "@/services";

// Importing Components
const ChatWindow = () =>
  import(/* webpackChunkName: "chat-window" */ "./ChatWindow");
const ChatButton = () =>
  import(/* webpackChunkName: "chat-button" */ "./ChatButton");

export default {
  name: "MachaApp",
  data() {
    return {
      chatWindow: {
        show: false,
        initialised: false,
      },
      chatButton: {
        show: true,
      },
      widget: {},
      sourceURL: null,
      liveChatActive: false,
    };
  },
  components: {
    ChatWindow,
    ChatButton,
  },
  async created() {
    this.getWidget();
  },
  mounted() {
    window.addEventListener("message", this.handleParentEvents);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleParentEvents);
  },
  methods: {
    // Get the widget
    async getWidget() {
      const widgetID = this.$route.query.widgetID;
      this.sourceURL = this.$route.query.source_url;

      if (widgetID) {
        const response = await WidgetService.GetWidget({ widgetID });

        if (!response.hasError && response.data.widgetID) {
          this.widget = response.data;
          this.initWidget();
        } else {
          this.hideWidget(response.data.handoff ? true : false);
        }
      }
    },

    // Initialise the widget
    initWidget() {
      const { position, zIndex, size, show } = this.widget.button;
      this.emitIframeEvent("widgetReady", { position, zIndex, size, show });

      this.initHandoff();
    },

    // Hide widget
    hideWidget(showHandoff = false) {
      window.parent.postMessage(
        { event: "hideWidget", showHandoff },
        this.sourceURL
      );
    },

    // Toggle the widget
    toggleWidget() {
      this.chatButton.show = !this.chatButton.show;
      this.chatWindow.show = !this.chatWindow.show;
      this.chatWindow.initialised = true;

      this.emitIframeEvent("toggleWidget");
    },

    // Init handoff chat
    initHandoff() {
      setTimeout(() => {
        const { appType } = this.widget.handoff.channels.agent;
        this.emitIframeEvent("initHandoff", {}, appType);
        console.log("🚀 Initialising handoff -", appType);
      }, 1500);
    },

    // Show human agent
    showLiveChat() {
      this.toggleWidget();

      const { appType } = this.widget.handoff.channels.agent;
      this.emitIframeEvent("showLiveChat", appType);
    },

    // Handler to emit Iframe events
    emitIframeEvent(event, message = false, messageType = false) {
      window.parent.postMessage(
        { event, message, messageType, type: "window" },
        this.sourceURL
      );
    },
  },
};
</script>